import React from "react";
import {useSelector} from "react-redux";

import {DeliveryZoneMap} from "../components/maps/DeliveryZoneMap";
import {SectionTitle} from "../components/common/sectionTitle/SectionTitle";
import {settingSelectors} from "../components/settings/_core/settingSelectors";
import {scrollToTop} from "../utils/scrollToAnchor";


export const DeliveryZonePage = () => {
	const content = useSelector(settingSelectors.content);
	scrollToTop()

	return (
		<div className="content-page">
			<SectionTitle title="зона доставки"/>
			<div dangerouslySetInnerHTML={{__html: content.delivery_contacts}}/>
			<DeliveryZoneMap/>
			<div dangerouslySetInnerHTML={{__html: content.delivery}}/>
			<br/>
		</div>
	)
};
